import { FC, useState } from "react";
import { PickerModal, PickerTabs } from "./PickerModal";
import { SAMPLE_AVATARS } from "../data";

/**
 * 选择数字人弹窗（公共组件）
 * - 公共形象 / 我的形象 页签
 * - 单选卡片，选中态黑描边
 */
export const AvatarPickerModal: FC<{
  value: string;
  onClose: () => void;
  onConfirm: (name: string) => void;
}> = ({ value, onClose, onConfirm }) => {
  const [tab, setTab] = useState("public");
  const [picked, setPicked] = useState(value);
  const list = SAMPLE_AVATARS.filter((a) => (tab === "public" ? a.scope === "public" : a.scope === "mine"));

  return (
    <PickerModal
      eyebrow="AVATAR"
      title="选择数字人"
      width={720}
      onClose={onClose}
      footerLeft="透明形象可独立移动；原有素材仅支持整体调整"
      confirmText="确认选择"
      confirmDisabled={!picked}
      onConfirm={() => onConfirm(picked)}
    >
      <PickerTabs
        items={[
          { key: "public", label: "公共形象" },
          { key: "mine", label: "我的形象" },
        ]}
        value={tab}
        onChange={setTab}
      />
      <div className="adh-apk-grid">
        {list.map((a) => (
          <button
            key={a.id}
            type="button"
            className={`adh-apk-card${picked === a.name ? " active" : ""}`}
            onClick={() => setPicked(a.name)}
          >
            <span className="adh-apk-portrait">
              <i />
            </span>
            <strong>{a.name}</strong>
            <small>已完成 · {a.scope === "public" ? "公共形象" : "我的形象"} · 透明形象</small>
          </button>
        ))}
      </div>
    </PickerModal>
  );
};
